/** API / enum string values sent by the backend (AchievementRarity). */
export const ACHIEVEMENT_RARITY_API_VALUES = ['Common', 'Rare', 'Epic'] as const;

export type AchievementRarityApiValue = (typeof ACHIEVEMENT_RARITY_API_VALUES)[number];

/** Map API rarity string to localized label (player + admin UI). */
export function formatAchievementRarity(
  rarity: string,
  t: (key: string, fallback?: string) => string
): string {
  const n = (rarity?.trim().toLowerCase() || '');
  if (n === 'epic') return t('achievements.rarity.epic', 'Epic');
  if (n === 'rare') return t('achievements.rarity.rare', 'Rare');
  if (n === 'common') return t('achievements.rarity.common', 'Common');
  return rarity?.trim() || t('achievements.rarity.unknown', 'Unknown');
}
